import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./app/App";
import configureStore, { sagaMiddleware } from "./store/configure-store";
import * as serviceWorker from "./serviceWorker";
import rootSaga from "./sagas";
import LoadingState from "./utils/LoadingState";
import Loading from "./commons/loading/components/loading";
import ResetAccountPassword from "./views/password/components/reset-password";
import { SOMETHING_WENT_WRONG_MESSAGE } from "./constants";

const store = configureStore();
sagaMiddleware.run(rootSaga);

const config = {
  core: {
    apiUrl: process.env.REACT_APP_API_BASE
  },
  isLoading: (loading) => {
    if (loading) {
      document
        .getElementById("cred-card-form-spinner")
        ?.classList?.remove("d-none");
      document
        .getElementById("ps-payments-formholder")
        ?.classList?.add("opacity-2");
    } else {
      document
        .getElementById("cred-card-form-spinner")
        ?.classList?.add("d-none");
      document
        .getElementById("ps-payments-formholder")
        ?.classList?.remove("opacity-2");
    }
  }
};

const loadingState = new LoadingState({
  isLoading: config.isLoading
});

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/reset-password">
          <ResetAccountPassword config={config} loadingState={loadingState} />
        </Route>
        <Route path="/:shortName">
          <App config={config} loadingState={loadingState} />
        </Route>
        <Route path="/">
          <Loading
            isFetching={false}
            hasData={false}
            hasError
            errorMsg={SOMETHING_WENT_WRONG_MESSAGE}
          />
        </Route>
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("ps-streams-container")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
